const styles = {
  root: {
    height: '50% !important',
    top: '50% !important',
  },
};

export default styles;



// WEBPACK FOOTER //
// ./src/containers/flights/mobile/passengersCounter/PassengersCounterDialogStyles.js